// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from '@/App';
// import router from '@/router';
import vuex from '@/store';
import { Message } from 'element-ui';
import VueClipboard from 'vue-clipboard2';
import './styles/reset.css';
import jquery from 'jquery';
import bus from '@/assets/js/event-bus';
import api from '@/api';
import string from './string';
import 'babel-polyfill';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.prototype.$ = jquery;
Vue.prototype.$bus = bus;
Vue.prototype.$http = api;
Vue.prototype.$str = string;
Vue.prototype.$toast = Message;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuex,
  // router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js